import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Categories from "./pages/Categories";
import CategoryDetail from "./pages/CategoryDetail";
import PolymerDetail from "./pages/PolymerDetail";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Contact from "./pages/Contact";
import SupplierCenter from "./pages/SupplierCenter";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import EditToolbar from "./components/EditToolbar";
import { NEWS_ENABLED } from "./mock";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/product-categories" element={<Categories />} />
            <Route path="/products/commodity-plastic-resin" element={<PolymerDetail />} />
            <Route path="/products/ppe-polyphenylene-ether" element={<PolymerDetail />} />
            <Route path="/products/:slug" element={<CategoryDetail />} />
            <Route path="/news" element={NEWS_ENABLED ? <News /> : <Navigate to="/" replace />} />
            <Route path="/news/:slug" element={NEWS_ENABLED ? <NewsDetail /> : <Navigate to="/" replace />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/supplier-center" element={<SupplierCenter />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <ContentProvider>
              <AppRoutes />
              <EditToolbar />
            </ContentProvider>
          </AuthProvider>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
